class Knowledge {
	async getFolderList(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-folders-document/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async getTagList() {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/tag-list`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async uploadDocument(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-document`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async createFolder(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-folder`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return response.json()
	}

	async rankingList(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-ranking/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async documentRankingList(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-document-ranking/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async empRankingList(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-employee-ranking/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async deleteFolder(folderId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-folder/${folderId}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async deleteDocument(documenId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-document/${documenId}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async searchDocuments(companyId, author, title, tag, order = '') {
		const response = await fetch(
			`${process.env.REACT_APP_API}/documents/knowledge-document-list/${companyId}?author=${author}&title=${title}&tag=${tag}&order=${order}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return response.json()
	}

	async favoriteDocument(docId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-highlight/${docId} `, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async likeDocument(docId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-document/${docId}/like `, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async viewDocument(docId) {
		const response = await fetch(`${process.env.REACT_APP_API}/documents/knowledge-view/${docId} `, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}
}

export default new Knowledge()
